import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ArrowLeft, Shield, FileText, Lock, Users, Scale, AlertTriangle, Database } from 'lucide-react';

const PoliciesPage = () => {
  const policies = [
    {
      id: 'terms',
      icon: FileText,
      title: 'Terms of Service',
      description: 'Our agreement with users regarding platform usage and responsibilities.'
    },
    {
      id: 'privacy',
      icon: Lock,
      title: 'Privacy Policy',
      description: 'How we collect, use, and protect your personal information.'
    },
    {
      id: 'refund',
      icon: Scale,
      title: 'Refund & Dispute Policy',
      description: 'Our process for handling service concerns and disputes.'
    },
    {
      id: 'acceptable-use',
      icon: AlertTriangle,
      title: 'Acceptable Use Policy',
      description: 'Guidelines for appropriate platform usage.'
    },
    {
      id: 'mechanic-standards',
      icon: Users,
      title: 'Mechanic Standards',
      description: 'Quality standards our mechanics must meet.'
    },
    {
      id: 'data-usage',
      icon: Database,
      title: 'Data Usage & Analytics',
      description: 'How we use service data to improve the platform.'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center" data-testid="logo-link">
              <img src="/logo.png" alt="Mechanicease" className="h-14 w-auto" />
            </Link>
            <Button variant="outline" asChild>
              <Link to="/">Back to Home</Link>
            </Button>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-slate-900 py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 bg-orange-500/10 border border-orange-500/20 rounded-full px-4 py-2 mb-6">
            <Shield className="w-4 h-4 text-orange-500" />
            <span className="text-orange-500 text-sm font-medium">Legal & Policies</span>
          </div>
          <h1 className="font-['Barlow'] text-4xl md:text-5xl font-bold text-white mb-4">
            Our Policies
          </h1>
          <p className="text-slate-300 text-lg">
            Transparency and trust are at the core of Mechanicease. Review our policies below.
          </p>
        </div>
      </section>

      {/* Policy Links */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-6">
            {policies.map((policy) => (
              <Link key={policy.id} to={`/policies/${policy.id}`}>
                <Card className="bg-white border border-slate-200 hover:border-orange-300 hover:shadow-md transition-all h-full">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-orange-50 rounded-lg flex items-center justify-center flex-shrink-0">
                        <policy.icon className="w-6 h-6 text-orange-500" />
                      </div>
                      <div>
                        <h3 className="font-['Barlow'] text-lg font-bold text-slate-900 mb-1">
                          {policy.title}
                        </h3>
                        <p className="text-slate-600 text-sm">{policy.description}</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 py-8 border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-slate-500 text-sm">© 2024 Mechanicease. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PoliciesPage;
